<template>

    <v-snackbar top vertical v-model="$store.state.alarmSnackbar.active" :timeout="timeout" @input="snackbarTimeout" v-if="$store.state.alarmSnackbar.alarms.length">
        <div>
            <div v-for="(alarm, index) in $store.state.alarmSnackbar.alarms" :key="index" class="snackbar-alarm-container">
                <div class="icon-container">
                    <v-icon :color="alarm.color">mdi-bell-ring</v-icon>
                </div>
                <div class="info-container">
                    <span class="severity" :style="{color: alarm.color}">{{alarm.severity}}: </span>
                    <span v-text="`${alarm.office} • ${alarm.location}`" />
                    <span class="desc" v-text="alarm.description" />
                </div>
                <div class="actions-container">
                    <v-btn @click="ackSingleAlarm(alarm)" class="mt-0 mr-1" text :color="alarm.color">ack</v-btn>
                    <v-divider vertical color="#ffffff" class="divider"></v-divider>
                    <v-btn @click="removeAlarm(alarm)" class="mt-0" icon color="#ffffff"><v-icon>mdi-close</v-icon></v-btn>
                </div>

                <v-divider v-if="$store.state.alarmSnackbar.alarms.length > 1" class="mt-2 mb-2"></v-divider>
            </div>
        </div>

        <div class="all-actions-container" v-if="$store.state.alarmSnackbar.alarms.length > 1">
            <v-btn class="mt-0" text @click="ackAllAlarms" color="#ffffff">ack all</v-btn>
            <v-divider vertical color="#ffffff" class="divider"></v-divider>
            <v-btn class="mt-0" text @click="removeAllAlarms" color="#ffffff">close all</v-btn>
        </div>
    </v-snackbar>

</template>

<script>
import Vue from "vue";
export default {
    name: 'AlarmSnackbar',
    components: {
    },
    data: () => ({

    }),

    computed: {
        timeout() {
            return this.$store.state.batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarTimeout
        }
    },

    methods: {
        ackAlarms: function(alarms) {
            let route = (TELSA.apiHost + "alarms/acknowledge");
            let alarmIDs = alarms.map(r => r.alarm_id);
            return this.$http.post(route, {args: {alarmIDs: alarmIDs}}).then(response => {
                let failed = response.body;
                TELSA.loading(false);
                if(failed) {
                    this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>acknowledge</b> the following alarms: </br></br> • ${failed}`});
                }
            });
        },

        ackSingleAlarm: function(alarm) {
            this.ackAlarms([alarm]);
            this.removeAlarm(alarm);
        },

        removeAlarm: function(alarm) {
            let list = this.$store.state.alarmSnackbar.alarms;
            let index = list.indexOf(alarm);
            if(index > -1) {
                list.splice(index, 1);
                this.$store.commit('setAlarmSnackbar', list);
            }
        },

        ackAllAlarms: function() {
            this.ackAlarms(this.$store.state.alarmSnackbar.alarms);
            this.removeAllAlarms();
        },

        removeAllAlarms: function() {
            this.$store.commit('setAlarmSnackbar', []);
        },

        snackbarTimeout: function() {
            this.$store.commit('setAlarmSnackbar', []);
        },

    },

    watch: {
    },

    mounted() {
    },

    destroyed() {
        console.log('snackbar destroyed!!');
    }

  
};
</script>

<style>

    .v-snack:not(.v-snack--absolute) {
        height: auto;
    }

</style>

<style scoped>

    .snackbar-alarm-container {
        width: 100%;
    }

    .snackbar-alarm-container:last-child {
        margin-bottom: 8px;
    }

    .icon-container {
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        margin-right: 5px;
    }
    .icon-container i {
        font-size: 30px;
    }

    .info-container {
        display: inline-block;
    }
    .info-container .severity {
        font-weight: bold;
    }
    .info-container .desc {
        display: block;
    }

    .actions-container {
        display: inline-block;
        margin-left: 3px;
        vertical-align: top;
        float: right;
    }
    .actions-container .divider {
        height: 15px;
        color: #ffffff;
    }

    .all-actions-container {
        text-align: center;
    }
    .all-actions-container .divider {
        height: 15px;
        color: #ffffff;
        margin-left: 5px;
    }

</style>
